import React from 'react';
import { Col, Row } from 'react-bootstrap';

import {
  configureSharedChannelsCartQueries,
  SharedChannelsFilter,
  SharedChannelsTable,
} from '@components/Order/SharedChannels';
import { sharedChannelsCartApi } from '@reducers/order';

export const SharedChannels = () => {
  const props = configureSharedChannelsCartQueries();

  return (
    <Row>
      <Col md={3}>
        <SharedChannelsFilter />
      </Col>
      <Col md={9}>
        <SharedChannelsTable
          useData={sharedChannelsCartApi.useGetCartQuery}
          cartProps={props}
        />
      </Col>
    </Row>
  );
};
